const renderOrbitBall = () => {
  window.onload = function () {
    console.log("orbit");
    //隱藏滑鼠
    document.body.style.cursor = "none";

    var canvas = document.getElementById("canvas"),
      context = canvas.getContext("2d"),
      width = (canvas.width = window.innerWidth),
      height = (canvas.height = window.innerHeight);

    var mousePos = { x: 0, y: 0 };
    var time = 0;

    var points = [];
    var sticks = [];
    var bounce = 1;
    var gravity = 0;
    var friction = 0.95;

    //第一個點
    pushPoint(0, 0, 10, 10);
    pushPoint(10, 10, 20, 20);
    pushPoint(20, 20, 30, 30);

    pushStick(0, 1);
    pushStick(1, 2);

    update();
    dynamicGravity();

    function update() {
      updatePoints(mousePos.x, mousePos.y);
      for (var i = 0; i < 5; i++) {
        updateSticks();
        constrainPoints();
      }
      renderPoints();
      renderSticks();

      requestAnimationFrame(update);
    }
    function getMousePos(canvas, evt) {
      var rect = canvas.getBoundingClientRect();
      return {
        x: evt.clientX - rect.left,
        y: evt.clientY - rect.top,
      };
    }

    function dynamicGravity() {
      time = time + 0.2;
      //gravity = Math.cos(time * 0.5)/10 ;
      gravity = Math.sin(time * 0.025) * 0.025;
      //console.log(gravity);
      requestAnimationFrame(dynamicGravity);
    }

    function distance(p0, p1) {
      var dx = p1.x - p0.x,
        dy = p1.y - p0.y;
      return Math.sqrt(dx * dx + dy * dy);
    }

    function pushPoint(x, y, oldx, oldy) {
      points.push({
        x: x,
        y: y,
        oldx: oldx,
        oldy: oldy,
      });
    }

    function pushStick(p0Index, p1Index) {
      sticks.push({
        p0: points[p0Index],
        p1: points[p1Index],
        width: 1,
        //length: distance(points[1], points[2]),
        color: "#a5a5a5",
        length: 30,
      });
    }

    function updatePoints(x, y) {
      for (var i = 0; i < points.length; i++) {
        if (i == 0) {
          var p = points[0];
          p.oldx = p.x;
          p.oldy = p.y;
          p.x = x;
          p.y = y;
          p[0] = p;
          continue;
        }
        var p = points[i],
          vx = (p.x - p.oldx) * friction,
          vy = (p.y - p.oldy) * friction;

        p.oldx = p.x;
        p.oldy = p.y;
        p.x += vx;
        p.y += vy;
        p.y += gravity;

        //反彈牆壁
        if (p.x > width) {
          p.x = width;
          p.oldx = p.x + vx * bounce;
        } else if (p.x < 0) {
          p.x = 0;
          p.oldx = p.x + vx * bounce;
        }
        if (p.y > height) {
          p.y = height;
          p.oldy = p.y + vy * bounce;
        } else if (p.y < 0) {
          p.y = 0;
          p.oldy = p.y + vy * bounce;
        }
      }
    }

    function constrainPoints() {
      for (var i = 0; i < points.length; i++) {
        var p = points[i];
        var vx = (p.x - p.oldx) * friction;
        var vy = (p.y - p.oldy) * friction;

        if (p.x > width) {
          p.x = width;
          p.oldx = p.x + vx * bounce;
        } else if (p.x < 0) {
          p.x = 0;
          p.oldx = p.x + vx * bounce;
        }
        if (p.y > height) {
          p.y = height;
          p.oldy = p.y + vy * bounce;
        } else if (p.y < 0) {
          p.y = 0;
          p.oldy = p.y + vy * bounce;
        }
      }
    }
    function updateSticks() {
      for (var i = 0; i < sticks.length; i++) {
        var s = sticks[i],
          dx = s.p1.x - s.p0.x,
          dy = s.p1.y - s.p0.y,
          distance = Math.sqrt(dx * dx + dy * dy),
          difference = s.length - distance,
          percent = difference / distance / 2,
          offsetX = dx * percent,
          offsetY = dy * percent;

        s.p0.x -= offsetX;
        s.p0.y -= offsetY;
        s.p1.x += offsetX;
        s.p1.y += offsetY;
      }
    }
    function renderSticks() {
      for (var i = 0; i < sticks.length; i++) {
        var s = sticks[i];
        if (!s.hidden) {
          context.beginPath();
          context.strokeStyle = s.color ? s.color : "black";
          context.lineWidth = s.width ? s.width : 1;
          context.moveTo(s.p0.x, s.p0.y);
          context.lineTo(s.p1.x, s.p1.y);
          context.stroke();
        }
      }
    }
    function renderPoints() {
      context.clearRect(0, 0, width, height);
      for (var i = 0; i < points.length; i++) {
        //不渲染第一顆?
        //第一顆放大
        var p = points[i];
        context.beginPath();
        if (i == 0) {
          context.fillStyle = "#e5e5e555";
          context.arc(p.x, p.y, 15, 0, Math.PI * 2);
          context.fill();

          context.strokeStyle = "#ccc";
          context.stroke();

          context.beginPath();
          context.fillStyle = "#0009";
          context.arc(p.x, p.y, 4, 0, Math.PI * 2);
          context.strokeStyle = "#fff";
          context.stroke();
        } else {
          context.fillStyle = "#f4f4f4";
          context.arc(p.x, p.y, 5, 0, Math.PI * 2);
        }
        context.fill();
      }
    }

    document.body.addEventListener("mousemove", function (event) {
      mousePos = getMousePos(canvas, event);
    });

    //取消滑鼠右鍵選單
    document.body.addEventListener("contextmenu", function (event) {
      event.preventDefault();
      return false;
    });

    //點擊時新增/刪減一個球
    document.body.addEventListener("mousedown", function (event) {
      //按下滑鼠右鍵=刪除一顆球
      if (event.which == 3) {
        console.log("rk");
        if (points.length > 3) {
          points.pop();
          sticks.pop();
        }
      } else if (event.which == 1) {
        if (points.length < 99) {
          var lastP = points[points.length - 1];
          pushPoint(lastP.x, lastP.y, lastP.oldx, lastP.oldy);
          pushStick(points.length - 2, points.length - 1);
        }
      }
    });
  };
};

export default renderOrbitBall;
